import { all, take, put, call } from 'redux-saga/effects';
import {
  JWT_TOKEN_KEY,
  JWT_REFRESH_KEY,
  setLocalStoreValue,
  removeLocalStoreValues,
} from '../utils/localStorage';

import {
  MANAGE_LOGIN,
  MANAGE_LOGIN_SUCCESS,
  MANAGE_LOGIN_FAILURE,
  MANAGE_LOGIN_NEEDS_TEAM,
  MANAGE_LOGOUT,
  MANAGE_FETCH_MEMBERSHIP,
  MANAGE_CANCEL_MEMBERSHIP,
  MANAGE_CANCEL_MEMBERSHIP_REQUEST,
  MANAGE_CANCEL_MEMBERSHIP_SUCCESS,
  MANAGE_CANCEL_MEMBERSHIP_FAILURE,
  MANAGE_REACTIVATE_MEMBERSHIP,
  MANAGE_REACTIVATE_MEMBERSHIP_SUCCESS,
  MANAGE_REACTIVATE_MEMBERSHIP_FAILURE,
  MANAGE_UPDATE_BILLING,
  MANAGE_UPDATE_BILLING_SUCCESS,
  MANAGE_UPDATE_BILLING_FAILURE,
  MANAGE_DELETE_ACCOUNT,
  MANAGE_DELETE_ACCOUNT_SUCCESS,
  MANAGE_DELETE_ACCOUNT_FAILURE,
  MANAGE_UPGRADE_MEMBERSHIP,
  MANAGE_UPGRADE_MEMBERSHIP_SUCCESS,
  MANAGE_UPGRADE_MEMBERSHIP_FAILURE,
  MANAGE_VALIDATE_COUPON,
  manageFetchMembership,
} from '../actions/subscriptionActions';

import {
  login,
  fetchMembership,
  fetchCancellationReasons,
  fetchMembershipOptions,
  cancelMembership,
  reactivateMembership,
  updateBilling,
  deleteAccount,
  upgradeMembership,
  validateCoupon,
} from '../apiActions/subscriptionApiActions';

export default function* subscriptionSagas() {
  yield all([loginSaga(), fetchMembershipSaga(), cancelSaga(), reactivateSaga(), updateBillingSaga(), deleteAccountSaga(), upgradeMembershipSaga(), validateCouponSaga(), logoutSaga()]);
}

function* loginSaga() {
  while (true) {
    const { username, password, teamId } = yield take(MANAGE_LOGIN);
    yield put(login(username, password, teamId));

    const result = yield take([MANAGE_LOGIN_SUCCESS, MANAGE_LOGIN_FAILURE]);
    if (result.type === MANAGE_LOGIN_SUCCESS) {
      const { token, refresh_token, teams_list } = result.data;

      if (teams_list && teams_list.length > 0 && !token) {
        yield put({
          type: MANAGE_LOGIN_NEEDS_TEAM,
          teamsList: teams_list,
          pendingCredentials: { username, password },
        });
      } else {
        yield call(setLocalStoreValue, JWT_TOKEN_KEY, token);
        yield call(setLocalStoreValue, JWT_REFRESH_KEY, refresh_token);
        yield put(manageFetchMembership());
      }
    }
  }
}

function* fetchMembershipSaga() {
  while (true) {
    yield take(MANAGE_FETCH_MEMBERSHIP);
    yield put(fetchMembership());
    yield put(fetchCancellationReasons());
    yield put(fetchMembershipOptions());
  }
}

function* cancelSaga() {
  while (true) {
    const { membershipId, cancellationReasonId } = yield take(MANAGE_CANCEL_MEMBERSHIP);
    yield put({ type: MANAGE_CANCEL_MEMBERSHIP_REQUEST });
    yield put(cancelMembership(membershipId, cancellationReasonId));

    const result = yield take([MANAGE_CANCEL_MEMBERSHIP_SUCCESS, MANAGE_CANCEL_MEMBERSHIP_FAILURE]);
    if (result.type === MANAGE_CANCEL_MEMBERSHIP_SUCCESS) {
      yield put(manageFetchMembership());
    }
  }
}

function* reactivateSaga() {
  while (true) {
    const { membershipId } = yield take(MANAGE_REACTIVATE_MEMBERSHIP);
    yield put(reactivateMembership(membershipId));

    const result = yield take([
      MANAGE_REACTIVATE_MEMBERSHIP_SUCCESS,
      MANAGE_REACTIVATE_MEMBERSHIP_FAILURE,
    ]);
    if (result.type === MANAGE_REACTIVATE_MEMBERSHIP_SUCCESS) {
      yield put(manageFetchMembership());
    }
  }
}

function* updateBillingSaga() {
  while (true) {
    const { membershipId, paymentMethodId } = yield take(MANAGE_UPDATE_BILLING);
    yield put(updateBilling(membershipId, paymentMethodId));

    const result = yield take([MANAGE_UPDATE_BILLING_SUCCESS, MANAGE_UPDATE_BILLING_FAILURE]);
    if (result.type === MANAGE_UPDATE_BILLING_SUCCESS) {
      yield put(manageFetchMembership());
    }
  }
}

function* deleteAccountSaga() {
  while (true) {
    yield take(MANAGE_DELETE_ACCOUNT);
    yield put(deleteAccount());

    const result = yield take([MANAGE_DELETE_ACCOUNT_SUCCESS, MANAGE_DELETE_ACCOUNT_FAILURE]);
    if (result.type === MANAGE_DELETE_ACCOUNT_SUCCESS) {
      yield call(removeLocalStoreValues);
    }
  }
}

function* upgradeMembershipSaga() {
  while (true) {
    const { membershipId, productId, enteredCoupon } = yield take(MANAGE_UPGRADE_MEMBERSHIP);
    yield put(upgradeMembership(membershipId, productId, enteredCoupon));

    const result = yield take([MANAGE_UPGRADE_MEMBERSHIP_SUCCESS, MANAGE_UPGRADE_MEMBERSHIP_FAILURE]);
    if (result.type === MANAGE_UPGRADE_MEMBERSHIP_SUCCESS) {
      yield put(manageFetchMembership());
    }
  }
}

function* validateCouponSaga() {
  while (true) {
    const { enteredCoupon, productId } = yield take(MANAGE_VALIDATE_COUPON);
    yield put(validateCoupon(enteredCoupon, productId));
  }
}

function* logoutSaga() {
  while (true) {
    yield take(MANAGE_LOGOUT);
    yield call(removeLocalStoreValues);
  }
}
